import { CostCenterService } from "./CostCenterService";

export type { ICostCenterService } from "./ICostCenterService";

export const costCenterService = new CostCenterService();
